<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月10日 16:01:48 +0800
 * @最后修改时间: 2021-12-13 16:50:17
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterTemplate\newRosterTemplate.vue
 -->
<template>
  <ContentLayout
    pad="0"
    widthClass="max-1000"
    :title="$t('label_essweb_RosterTemplate_form_newTitle')"
    :initData="RosterTemplateData"
    @change="(changed) => (isChanged = changed)"
    backgroundClass="white"
    :checkData="[
      'roster_weekly_template_name',
      'roster_weekly_template_code',
      'std_work_integer',
      'std_work_text',
      'start_utc_datetime',
      'roster_weekly_template_description',
      'is_default',
      'remarks',
    ]"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row dense>
              <v-col xs="12" sm="12" md="8" lg="8" cols="12">
                <inputTextFiledMultiLang
                  :bindData="RosterTemplateData.roster_weekly_template_name"
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      RosterTemplateData.roster_weekly_template_name = valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_RosterTemplate_form_rosterTemplateNameLabel'
                    )
                  "
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="4" lg="4" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_ClaimReason_form_codeLabel')"
                  maxlength="100"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="RosterTemplateData.roster_weekly_template_code"
                />
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <inputTextFiledMultiLang
                  maxlength="500"
                  :bindData="
                    RosterTemplateData.roster_weekly_template_description
                  "
                  @change="
                    (valueArr) => {
                      RosterTemplateData.roster_weekly_template_description =
                        valueArr;
                    }
                  "
                  :label="
                    $t(
                      'label_essweb_RosterTemplate_form_rosterTemplateDescriptionLabel'
                    )
                  "
                />
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <DateTimePicker
                  type="date"
                  :label="
                    $t('label_essweb_RosterFormRecord_list_startDateLabel')
                  "
                  :defaultTime="RosterTemplateData.start_utc_datetime"
                  placeholder="YYYY/MM/DD"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  @change="
                    (time) => {
                      RosterTemplateData.start_utc_datetime = time;
                    }
                  "
                />
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                <normalInputTextFiled
                  type="number"
                  maxlength="11"
                  v-model="RosterTemplateData.std_work_integer"
                  :rules="
                    $GetRules(['_Number_negative', '_Length_Rules'], [null, 11])
                  "
                  :label="
                    $t('label_essweb_RosterTemplate_form_stdWorkMinutesLabel')
                  "
                />
              </v-col>
              <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                <normalInputTextFiled
                  maxlength="100"
                  readonly
                  v-model="RosterTemplateData.std_work_text"
                  :label="
                    $t('label_essweb_RosterTemplate_form_stdWorkTimeLabel')
                  "
                />
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_RosterTemplate_form_remarkLabel")
                }}</v-sheet>
                <v-textarea
                  rows="5"
                  no-resize
                  maxlength="500"
                  dense
                  filled
                  counter="500"
                  single-line
                  v-model="RosterTemplateData.remarks"
                  name="input-7-4"
                ></v-textarea>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="ml-3">
                <v-checkbox
                  v-model="RosterTemplateData.is_default"
                  :label="$t('label_essweb_RosterTemplate_form_setAsDefault')"
                  color="primary"
                  required
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <Tabler
            :headers="headers"
            :items="desserts"
            :avPerPage="20"
            :showSelect="showSelect"
            :showFooter="false"
          >
            <template v-slot:top>
              <div class="mx-auto">
                <v-form ref="form2" lazy-validation>
                  <v-row dense>
                    <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                      <v-sheet class="mrc_text_require text--secondary">{{
                        $t("label_essweb_RosterTemplate_form_cycleTypeLabel")
                      }}</v-sheet>
                      <v-select
                        :items="CycleTypeList"
                        dense
                        filled
                        item-value="value_field"
                        item-text="view_fields"
                        hide-details
                        :menu-props="{
                          offsetY: true,
                          transition: 'slide-y-transition',
                          rounded: true,
                          contentClass: 'elevation-4',
                        }"
                        :placeholder="
                          $t('label_essweb_RosterTemplate_form_cycleTypeLabel')
                        "
                        :rules="$GetRules(['_Require_Rules'], [null])"
                        v-model="curCycleType"
                        single-line
                      >
                        <template v-slot:no-data> <noContent /> </template>
                        <template v-slot:selection="data">
                          {{ $getCommonLangValue(data.item.view_fields) }}
                        </template>
                        <template v-slot:item="data">
                          {{ $getCommonLangValue(data.item.view_fields) }}
                        </template>
                      </v-select>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
            </template>
            <template v-slot:item.sequence="{ item }">
              <div class="table-title text--primary">
                {{
                  curCycleType
                    ? $getCommonLangValue(
                        curWeek[Number(item.sequence)].view_fields
                      )
                    : item.sequence
                }}
              </div>
            </template>
            <template v-slot:item.name="{ item }">
              <div
                class="table-title text--primary"
                :title="
                  item.shift
                    ? $getCommonLangValue(item.shift.shift_name) +
                      '(' +
                      $timeMachine(item.shift.start_utc_time) +
                      ' - ' +
                      $timeMachine(item.shift.end_utc_time) +
                      ')'
                    : ''
                "
              >
                {{
                  item.shift
                    ? $getCommonLangValue(item.shift.shift_name) +
                      "(" +
                      $timeMachine(item.shift.start_utc_time) +
                      " - " +
                      $timeMachine(item.shift.end_utc_time) +
                      ")"
                    : ""
                }}
              </div>
            </template>
            <!-- action -->
            <template v-slot:item.action="{ item }">
              <v-btn icon @click="toEditProperty(item)">
                <span class="material-icons-round">add</span>
              </v-btn>
            </template>
          </Tabler>
        </template>
      </Stepper>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        :newBtn="stepper.length == curStep && curStep != 0 ? true : false"
        :step="stepper.length == curStep ? false : true"
        @next="toNext"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toNew"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <normalDialog
        deleteModel
        :dialog="showPGDelete"
        title="Event Property Group"
        @close="showPGDelete = false"
        @confirm="toDeletePG"
      />
      <editRosterTemplateDialog
        :show="showEditDialog"
        :curProperty="curProperty"
        @onEdit="onEditProperty"
        @close="showEditDialog = false"
      />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import editRosterTemplateDialog from "@/Page/EssAdmin/Roster/RosterTemplate/components/editRosterTemplateDialog";
export default {
  name: "newRosterTemplate",
  components: { editRosterTemplateDialog },
  computed: {
    ...mapGetters(["companyLang"]),
    desserts() {
      if (this.curCycleType) {
        return this.allDesserts.slice(0, Number(this.curCycleType) + 1);
      } else {
        return [];
      }
    },
    curWeek() {
      if (this.curCycleType == 7) return this.single_week;
      if (this.curCycleType == 14) return this.double_week;
    },
    curObject() {
      const that = this;
      var arr = [];
      that.canApproval = true;
      this.desserts.map(function (item) {
        if (item.shift) {
          arr.push({
            sequence: item.sequence,
            shift_uuid: item.shift.uuid,
            remarks: item.remarks,
          });
        } else {
          that.canApproval = false;
          arr.push(null);
        }
      });
      return arr;
    },
  },
  data() {
    return {
      curStep: 1,
      isChanged: false,
      stepper: [
        "label_essweb_RosterTemplate_form_step_generalLabel",
        "label_essweb_RosterTemplate_form_step_Mapping",
      ],
      canApproval: true,
      mapToDiag: false,
      showPGDelete: false,
      showEditDialog: false,
      selected: [],
      single_week: [],
      double_week: [],
      curCycleType: null,
      curProperty: null,
      CycleTypeList: [],
      curPropertyId: null,
      page: 1,
      showSelect: false,
      RosterTemplateData: {
        roster_weekly_template_name: "",
        roster_weekly_template_code: "",
        std_work_integer: 0,
        std_work_text: "00:00",
        roster_weekly_template_description: "",
        roster_type: "",
        start_utc_datetime: "",
        is_default: false,
        remarks: "",
      },
      allDesserts: [],
      headers: [
        {
          text: "label_essweb_RosterTemplate_form_list_sequenceLabel",
          value: "sequence",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_rosterForm_form_list_shiftTimeLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
    };
  },

  watch: {
    curObject() {
      // console.log("是否可提交:" + this.canApproval);
    },
    desserts(val) {
      // console.log(val);
    },
    "RosterTemplateData.std_work_integer": function (val) {
      if (val) {
        if (val.toString().length > 1 && val.toString()[0] == "0") {
          this.RosterTemplateData.std_work_integer = val
            .toString()
            .substring(1, val.toString().length);
        }
      }
      if (Number(val) > 0) {
        this.RosterTemplateData.std_work_text = this.$timeMachine(Number(val));
      } else {
        this.RosterTemplateData.std_work_text = "00:00";
      }
    },
  },
  mounted() {
    const that = this;
    //初始化
    for (var i = 0; i <= 14; i++) {
      this.allDesserts.push({
        sequence: i,
        shift: null,
        remarks: "",
      });
    }
    // 获取单周
    this.$findPrompt({
      prompt_name: "ess_single_week_roster_template_shift_sequence_select",
    }).then((res) => {
      that.single_week = res.data;
    });
    // 获取双周
    this.$findPrompt({
      prompt_name: "ess_biweekly_roster_template_shift_sequence_select",
    }).then((res) => {
      that.double_week = res.data;
    });
    // 获取cycleType
    this.$findPrompt({
      prompt_name: "ess_roster_template_period_type_select",
    }).then((res) => {
      res.data.map((item) => {
        item["value_field"] = Number(item["value_field"]);
      });
      that.CycleTypeList = res.data;
    });
    this.RosterTemplateData.roster_weekly_template_name =
      this.$getCommonLangKey(this.companyLang);
    this.RosterTemplateData.roster_weekly_template_description =
      this.$getCommonLangKey(this.companyLang);
  },
  methods: {
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
    toNext: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      if (!this.$refs["form2"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      if (!this.canApproval) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t(
            "message_essweb_RosterTemplate_list_RosterTemplateConfigisMustLabel"
          ),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_roster_weekly_template",
        url: "/roster-template/add/",
        data: {
          roster_weekly_template_name: this.$transCommonLangKey(
            this.RosterTemplateData.roster_weekly_template_name
          ),
          roster_weekly_template_description: this.$transCommonLangKey(
            this.RosterTemplateData.roster_weekly_template_description
          ),
          roster_weekly_template_code:
            this.RosterTemplateData.roster_weekly_template_code,
          roster_type: this.curCycleType,
          start_utc_datetime: this.$getTimeValue(
            this.RosterTemplateData.start_utc_datetime
          ),
          std_work_integer: this.RosterTemplateData.std_work_integer,
          std_work_text: this.RosterTemplateData.std_work_text,
          is_default: this.RosterTemplateData.is_default ? 1 : 0,
          remarks: this.RosterTemplateData.remarks,
          ess_att_map_roster_template_shift: this.curObject,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
    onEditProperty: function (obj) {
      const that = this;
      this.showEditDialog = false;
      this.allDesserts.some(function (item, index) {
        if (item.sequence == obj.sequence) {
          that.allDesserts.splice(index, 1, {
            sequence: obj.sequence,
            shift: obj.shift,
            remarks: obj.remarks,
          });
          return true;
        }
      });
    },
    toDeleteProperty: function (id) {
      const that = this;
      this.showPGDelete = true;
      this.curPropertyId = id;
    },
    toDeletePG: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "",
        url: "",
        data: { uuids: this.curPropertyId },
      }).then((res) => {
        that.$toBack();
      });
    },
    toEditProperty: function (item) {
      const that = this;
      setTimeout(function () {
        that.curProperty = {
          uuid: null,
          sequence: item.sequence,
          shift: item.shift,
          remarks: item.remarks,
        };
      }, 300);
      that.showEditDialog = true;
    },
  },
};
</script>
